<template>
  <v-container fluid>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <!--<v-dialog v-model="component_show" width="40%">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
      <v-card>
      <span>
        &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
        <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
      </span>
      </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>-->
    <v-row class="justify-center">
      <v-col cols="12" lg="10">
        <v-card class="card--group">
          <v-container>
            <v-row>
              <v-col cols="6" md="2">
                <gauge-card
                  title="발전량"
                  :max="siteTotal.totalCapacity * 1.1"
                  :value="siteTotal.pvpcsPac"
                  color="#90F072"
                  unit="KW"
                  :flag="flag"
                />
              </v-col>
              <v-col cols="6" md="2" v-show="!isMobilePc">
                <gauge-card
                  title="발전시간"
                  :max="9"
                  :value="siteTotal.dailyTime"
                  :flag="flag"
                  color="#FFD754"
                  unit="hr"
                />
              </v-col>
              <v-col cols="6" md="2">
                <text-card
                  title="당일 발전량"
                  :value="siteTotal.pvpcsDailyP / 1000"
                  color="#00FFFA"
                  unit="MWH"
                ></text-card>
              </v-col>
              <v-col cols="6" md="2" v-show="!isMobilePc">
                <text-card
                  title="총 사이트 용량"
                  :value="Math.floor(siteTotal.totalCapacity)"
                  color="#FFD754"
                  unit="KW"
                ></text-card>
              </v-col>
              <v-col cols="6" md="2">
                <state-table
                  title="사이트 현황"
                  state-name="총 사이트 수"
                  :state-value="siteTotal.totalCount"
                  :run-val="siteTotal.runCount + siteTotal.pauseCount"
                  :err-val="siteTotal.faultCount"
                  :str-val="siteTotal.errorCount"
                  :err-list="errorSiteList"
                  :fault-list="faultSiteList"
                ></state-table>
              </v-col>
              <v-col cols="6" md="2">
                <state-table
                  title="인버터 현황"
                  state-name="총 인버터 수"
                  :state-value="inverterTotal.totalCount"
                  :run-val="inverterTotal.runCount + inverterTotal.pauseCount"
                  :err-val="inverterTotal.faultCount"
                  :str-val="inverterTotal.errorCount"
                  :err-list="errorSiteList"
                  :fault-list="faultSiteList"
                ></state-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <!--          <v-checkbox label="전체" class="mr-2"></v-checkbox>-->
      <!--          <v-checkbox label="유료" class="mr-2"></v-checkbox>-->
      <!--          <v-checkbox label="무료" class="mr-2"></v-checkbox>-->
      <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
      <v-col cols="1">
        <v-select
          :items="sidoList"
          v-model="selectSido"
          outlined
          sm
          dense
          hide-details
        ></v-select>
      </v-col>
      <v-col>
        <v-card min-width="360" flat color="rgba(0,0,0,0)">
          <v-card-text class="d-inline-flex align-center py-0">
            <v-text-field
              class="pr-2"
              placeholder="사이트명을 입력하세요"
              outlined
              dense
              hide-details
              v-model="searchText"
              @keyup.enter="
                toggleEvent = !toggleEvent
                popup = true
              "
            ></v-text-field>
            <v-btn
              color="#0784F2"
              min-width="48"
              width="48"
              height="40"
              @click="
                toggleEvent = !toggleEvent
                popup = true
              "
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
    </v-row>
    <v-row class="justify-center">
      <template v-if="cardFilterList">
        <v-col
          cols="12"
          md="4"
          sm="4"
          lg="3"
          v-for="(sigu, index) in cardFilterList"
          :key="index"
        >
          <expansion-gauge-card
            :sido="sigu"
            :sigu-list="sigu.runList"
            :flag="flag"
            :sido-total="total"
          ></expansion-gauge-card>
        </v-col>
      </template>
    </v-row>
    <v-dialog v-model="popup" persistent max-width="450px" scrollable>
      <detail-status-popup
        @closeDetailPop="popup = false"
        :text.sync="searchText"
        :toggle-event="toggleEvent"
        status="search"
      ></detail-status-popup>
    </v-dialog>
  </v-container>
</template>

<script>
import { dateRenew } from '@/api/common/login'

import GaugeCard from '@/components/monitoring/GaugeCard'
import ExpansionGaugeCard from '@/components/monitoring/ExpansionGaugeCard'
import TextCard from '@/components/monitoring/TextCard'
import StateTable from '@/components/monitoring/StateTable'
import { getMonitoringTotal } from '@/api/monitoring/monitoring'
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import store from '@/store'
import { isMobile } from '@/utils/check.js'
import Message from '@/utils/message'

export default {
  name: 'Constructor',
  components: {
    GaugeCard,
    ExpansionGaugeCard,
    TextCard,
    StateTable,
    DetailStatusPopup,
    GeneralDialog
  },
  data() {
    return {
      row_num: 0,
      component_key: 1,
      layer_type: 'SummaryPopup',
      component_show: false,
      toggleEvent: false,
      sidoList: ['전체'],
      selectSido: '전체',
      isMobilePc: false,
      flag: 0,
      total: 0,
      searchText: '',
      searchType: 'site',
      popup: false,
      modal: false,
      popupTitle: '비밀번호 변경',
      pwChangeYN: localStore.get('pw_change'),
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      paramList: [],
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      cardList: {},
      sigu: {},
      intervalHandler: null
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.$store.dispatch('SetTabIndex', 0)
  },
  mounted() {
    this.popup2()
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    this.getData()
    if (isMobile()) {
      this.isMobilePc = true
    }
    this.intervalHandler = setInterval(() => {
      this.getData()
    }, 60000 * 2)
    if (this.pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
  },
  activated() {
    console.log('activated')
    this.getData()
    if (this.intervalHandler === null) {
      this.intervalHandler = setInterval(() => {
        this.getData()
      }, 60000 * 2)
    }
  },
  deactivated() {
    clearInterval(this.intervalHandler)
  },
  computed: {
    errorSiteList() {
      let result = []
      for (let key in this.cardList) {
        if (this.cardList[key].errorList.length > 0) {
          result.push(...this.cardList[key].errorList)
        }
      }
      return result
    },
    faultSiteList() {
      let result = []
      for (let key in this.cardList) {
        if (this.cardList[key].faultList.length > 0) {
          result.push(...this.cardList[key].faultList)
        }
      }
      return result
    },
    cardFilterList() {
      if (this.selectSido === '전체') {
        return this.cardList
      }
      this.flag++
      let result = []
      for (let key in this.cardList) {
        if (this.cardList[key].sidoName === this.selectSido) {
          result.push(this.cardList[key])
        }
      }
      return result
    }
  },
  methods: {
    popup2() {
      // 첫 화면에서 팝업을 띄운다
      this.layer_type = 'SummaryPopup'

      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }

      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }

      // this.component_show = true
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }
      // this.$emit('update:component_show', false)
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    },
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    fn1() {
      // 내부 state인 data영역은 this로 접근해야 한다.
      this.count++
    },
    clickMe() {
      this.value = this.value + 1
    },
    getSiguList(sidoCode) {
      const siguList = []
      for (let siguCode in this.sigu) {
        if (this.sigu[siguCode].sidoCode === sidoCode) {
          siguList.push(this.sigu[siguCode])
        }
      }
      return siguList
    },
    getData() {
      getMonitoringTotal(store.state.user.userId, 'sigu').then(res => {
        if (res.siteTotal) {
          this.siteTotal = new Object()
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = new Object()
          this.inverterTotal = res.inverterTotal
        }
        this.flag++
        if (res.sigu) {
          this.total = Object.keys(res.sigu).length
          this.cardList = new Array()
          this.cardList = res.sigu
          for (let key in this.cardList) {
            this.sidoList.push(this.cardList[key].sidoName)
            this.cardList[key].runList.push(...this.cardList[key].errorList)
            this.cardList[key].runList.push(...this.cardList[key].faultList)
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (this.intervalHandler) clearInterval(this.intervalHandler)
  }
}
</script>

<style lang="scss" scoped></style>
